import { createSelector } from 'reselect';
import { HIDDEN_STATUSES } from '../partnerIntegration/consts';

export const getPartnerIntegrationState = state => state.partnerIntegration;
export const getIntegrationRequests = createSelector(getPartnerIntegrationState, slice => slice.requests);
export const getPostbackMacroNetworkName = createSelector(getPartnerIntegrationState, slice => {
    const v = slice.postbackMacroNetworkName;
    if (v == null) return '';
    return typeof v === 'string' ? v.trim() : '';
});

export const getIntegrationRequestsLoading = createSelector(getPartnerIntegrationState, slice => slice.loading);
export const getIntegrationRequestsLoaded = createSelector(getPartnerIntegrationState, slice => slice.loaded);
export const getIntegrationRequestsError = createSelector(getPartnerIntegrationState, slice => slice.error);

export const getVisibleIntegrationRequests = createSelector(getIntegrationRequests, requests =>
    requests.filter(request => !HIDDEN_STATUSES.includes(request.status))
);

export const getHiddenRequestsByType = createSelector(getIntegrationRequests, requests =>
    requests
        .filter(r => HIDDEN_STATUSES.includes(r.status))
        .reduce((acc, r) => {
            if (!acc[r.request_type]) acc[r.request_type] = [];
            acc[r.request_type].push(r);
            return acc;
        }, {})
);
